import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class CaseApi extends ApiCommon {
  protected backend = environment.api.backend;

  getCases(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.case.getCases(builder.build());
  }

  exportCases(builder): Observable<any> {
    return this.apiServer.case.exportCases(builder);
  }

  getCase(caseNo): Observable<any> {
    return this.apiServer.case.getCase(caseNo);
  }

  saveCase(data): Observable<any> {
    return this.apiServer.case.saveCase(data);
  }

  deleteCase(data): Observable<any> {
    return this.apiServer.case.deleteCase(data);
  }

  updateCaseRejectTicket(data): Observable<any> {
    return this.apiServer.case.updateCaseRejectTicket(data);
  }

  saveCaseProduct(data): Observable<any> {
    return this.apiServer.case.saveCaseProduct(data);
  }

  deleteCaseProduct(data): Observable<any> {
    return this.apiServer.case.deleteCaseProduct(data);
  }

  getCheckSerial(data): Observable<any> {
    return this.apiServer.case.getCheckSerial(data);
  }

  getB2bSymptoms(data): Observable<any> {
    return this.apiServer.case.getB2bSymptoms(data);
  }

  serverFileUpload(formData): Observable<any> {
    return this.apiServer.case.serverFileUpload(formData);
  }

  deleteFile(data): Observable<any> {
    return this.apiServer.case.deleteFile(data);
  }

  workflowStatusUpdate(data): Observable<any> {
    return this.apiServer.case.workflowStatusUpdate(data);
  }

  caseProductApprove(data): Observable<any> {
    return this.apiServer.case.caseProductApprove(data);
  }

  updateTicketStatus(data): Observable<any> {
    return this.apiServer.case.updateTicketStatus(data);
  }

  updateTicketAscNo(data): Observable<any> {
    return this.apiServer.case.updateTicketAscNo(data);
  }

  updateExchangeReason(data): Observable<any> {
    return this.apiServer.case.updateExchangeReason(data);
  }

  updateTrackingStatus(data): Observable<any> {
    return this.apiServer.case.updateTrackingStatus(data);
  }

  changePartnerOrganization(data): Observable<any> {
    return this.apiServer.case.changePartnerOrganization(data);
  }
}
